<template>
  <profile-main>
    <profile-header activeMenu="invoiceInfo" slot="profileNavigation" />
    <form class="form-horizontal" method="post" @submit.prevent="doUpdate">
      <div class="form-group">
        <div class="col-md-12">
          <input-text
            type="text"
            name="name"
            :value="form.name"
            label="Name"
            @input="text => { setField({ key: 'name', value: text }) }"
          />
        </div>
      </div>
      <div class="form-group">
        <div class="col-md-12">
          <input-text
            type="text"
            name="address"
            :value="form.address"
            label="Addess"
            @input="text => { setField({ key: 'address', value: text }) }"
          />
        </div>
      </div>

      <div class="form-group">
        <div class="col-md-12">
          <input-text
            type="text"
            name="phone"
            :value="form.phone"
            label="Phone"
            @input="text => { setField({ key: 'phone', value: text }) }"
          />
        </div>
      </div>

      <div class="form-group">
        <div class="col-md-12">
          <input-text
            type="text"
            name="email"
            :value="form.email"
            label="Email"
            @input="text => { setField({ key: 'email', value: text }) }"
          />
        </div>
      </div>

      <div class="form-group">
        <div class="col-sm-12">
          <form-button
            type="info"
            inputType="submit"
            text="UPDATE"
            :disabled="loading"
            :loading="loading"
            :block="true"
          />
        </div>
      </div>
    </form>
  </profile-main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import InputText from "@/components/Form/InputText";
import FormButton from "@/components/Form/FormButton";
import LinkButton from "@/components/Misc/LinkButton";
import LoadingContainer from "@/components/Misc/LoadingContainer";

import ProfileHeader from './components/Header';
import ProfileMain from './components/Main';

export default {
  name: "InvoiceInfo",
  components: {
    InputText,
    FormButton,
    LinkButton,
    LoadingContainer,
    ProfileHeader,
    ProfileMain,
  },
  beforeMount() {
    this.getUserInfo();
  },
  computed: {
    ...mapGetters({
      form: "auth/invoiceForm",
      loading: "auth/loading",
    }),
  },
  methods: {
    ...mapActions({
      setField: 'auth/setInvoiceField',
      getUserInfo: "auth/getUserInfo",
      updateInvoiceInfo: "auth/updateInvoiceInfo",
    }),
    async doUpdate() {
      await this.updateInvoiceInfo();
    },

  }
};
</script>
